import React from "react";
import { Alert, Form, Icon, Input, Button, Row, Col, Upload } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import { uploadApiConfigurationRequest } from "../../../api/requests";

import classes from "../ApiConfiguration.css";
import { logout } from "../../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import {getFormErrorMessage} from "../../../utils/errorHandler";

class ApiImportForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const formData = new FormData();
          if (values.document_file && values.document_file.file) {
            formData.append("file", values.document_file.file);
          }

          await uploadApiConfigurationRequest(formData, this.props.id);

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: getFormErrorMessage(e, true),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t("NamespaceApiImportForm:Import API Mapping")}
          </h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("Select .csv")}</b> <i>semicolon separated <b>";"</b></i>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Upload
                      accept=".csv"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.url
                          ? "Change file"
                          : "Upload"}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>

              {!this.props.form.getFieldValue("document_file") &&
                this.props.url && (
                  <div>
                    <a href={this.props.url} target="_blank">
                      {this.props.url}
                    </a>
                    <br />
                    <br />
                  </div>
                )}
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.formActionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "ApiImportForm" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ApiImportForm))
);



// WEBPACK FOOTER //
// ./src/containers/ApiConfiguration/Form/ApiImportForm.js